/* eslint-disable @angular-eslint/no-output-native */
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  DynamicFormControlComponent,
  DynamicFormControlCustomEvent,
  DynamicFormControlLayout,
  DynamicFormLayout,
  DynamicFormLayoutService,
  DynamicFormValidationService,
  DynamicSliderModel,
} from '@ng-dynamic-forms/core';
import { NgClass } from '@angular/common';
import { NouisliderComponent, NouisliderModule } from 'ng2-nouislider';
import { NouiSliderConfig } from './dynamic-noui-slider.model';

@Component({
  selector: 'dynamic-noui-slider.component',
  templateUrl: './dynamic-noui-slider.component.html',
  styleUrls: ['./dynamic-noui-slider.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, NouisliderModule, NgClass],
})
// ng dynamic forms already have a slider model definition, only declaring the ui component
export class DynamicNouiSliderComponent extends DynamicFormControlComponent {
  @Input() formLayout?: DynamicFormLayout;
  @Input() group!: UntypedFormGroup;
  @Input() layout?: DynamicFormControlLayout;
  @Input() model!: DynamicSliderModel;

  @Output() blur: EventEmitter<any> = new EventEmitter();
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() customEvent: EventEmitter<DynamicFormControlCustomEvent> = new EventEmitter();
  @Output() focus: EventEmitter<any> = new EventEmitter();

  @ViewChild('nouiSlider', { static: true }) nouiSlider!: NouisliderComponent;

  constructor(
    protected layoutService: DynamicFormLayoutService,
    protected validationService: DynamicFormValidationService,
    public config: NouiSliderConfig
  ) {
    super(layoutService, validationService);
    // TODO: model/config mapping in case if needed
  }

  changeSlider(dif: number | null): void {
    if (this.model.min === null || this.model.max === null || !dif) {
      return;
    }
    // Prevent setting values outside the range
    if ((dif < 0 && this.control.value <= this.model.min) || (dif > 0 && this.control.value >= this.model.max)) {
      return;
    }
    this.control.patchValue(this.control.value + dif);
  }
}
